import { createFileRoute } from '@tanstack/react-router'
import EditionCategory from 'Edition/components/sections/Content/EditionCategory'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-categorization')({
    component: EditionCategory,
})
